import Button from './Button';
import Dialog from './Dialog';
import { Icon } from '@iconify/react';

const DeleteModal = ({
  show,
  onHide,
  onConfirm,
  title = "Delete Item",
  message = "Are you sure you want to delete this item?",
  loading = false,
}) => {
  return (
    <Dialog
      isOpen={show}
      onClose={onHide}
      title={title}
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={loading}>
            {loading ? 'Deleting...' : 'Delete'}
          </Button>
        </>
      }
    >
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center bg-red-100">
          <Icon icon="mdi:alert-circle" className="text-2xl text-red-600" />
        </div>
        <div className="flex-1">
          <p className="text-text-dark">{message}</p>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteModal;
